document.addEventListener('DOMContentLoaded', function() {
    const searchButton = document.querySelector('.search-button');
    const searchField = document.getElementById('search-field');
    
    if (searchButton && searchField) {
        searchButton.addEventListener('click', function(e) {
            if (searchField.value === '') {
                e.preventDefault();
                return false;
            }
        });
    }
});